import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=fea0063c&scoped=true&"
import script from "./Administrador.vue?vue&type=script&lang=js&"
export * from "./Administrador.vue?vue&type=script&lang=js&"
import style0 from "./Administrador.vue?vue&type=style&index=0&id=fea0063c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea0063c",
  null
  
)

export default component.exports